// extracted by mini-css-extract-plugin
export default {"playerCell":"playerCell-O_xe8TbJ","flag":"flag-bbTzYCfp","username":"username-ViDRb_a9"};